import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingModule } from 'shared/components/loading/loading.module';
import { WorkWidgetHeaderModule } from 'shared/components/work-widget-header/work-widget-header.module';
import { MessagingPreviewComponent } from 'components/queue-view/queue-view-tab/work-item-preview/messaging-preview/messaging-preview.component';
import { VisitorHistoryModule } from 'shared/components/visitor-history/visitor-history.module';
import { ChatMessagesModule } from 'shared/components/chat-messages/chat-messages.module';
import { TextChatActionsModule } from 'components/work-item-lane-list/work-item-lane/work-item-widget/text-chat-widget/text-chat-box/text-chat-actions/text-chat-actions.module';

@NgModule({
  imports: [
    CommonModule,
    LoadingModule,
    WorkWidgetHeaderModule,
    VisitorHistoryModule,
    ChatMessagesModule,
    TextChatActionsModule
  ],
  declarations: [
    MessagingPreviewComponent
  ],
  exports: [
    MessagingPreviewComponent
  ]
})
export class MessagingPreviewModule {}
